
export const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Dr. Sarah Kim',
      position: 'CEO & Co-Founder',
      bio: 'MIT 해양공학 박사, 전 구글 바이오랩 연구원',
      image: 'https://readdy.ai/project/36601293-3225-4aaf-b874-afc33c6d03c6/assets/images/team1.jpg',
      linkedin: '#'
    },
    {
      name: 'Dr. Michael Chen',
      position: 'CTO & Co-Founder',
      bio: '스탠포드 생명공학 박사, 12년 R&D 경험',
      image: 'https://readdy.ai/project/36601293-3225-4aaf-b874-afc33c6d03c6/assets/images/team2.jpg',
      linkedin: '#'
    },
    {
      name: 'Emily Johnson',
      position: 'VP of Operations',
      bio: '하버드 MBA, 전 맥킨지 컨설턴트',
      image: 'https://readdy.ai/project/36601293-3225-4aaf-b874-afc33c6d03c6/assets/images/team3.jpg',
      linkedin: '#'
    },
    {
      name: 'Dr. James Park',
      position: 'Head of Research',
      bio: 'KAIST 화학공학 박사, 국제 특허 25건 보유',
      image: 'https://readdy.ai/project/36601293-3225-4aaf-b874-afc33c6d03c6/assets/images/team4.jpg',
      linkedin: '#'
    }
  ];

  const advisors = [
    {
      name: 'Prof. David Wilson',
      position: 'MIT 교수, 해양공학과',
      company: '기술 자문'
    },
    {
      name: 'Lisa Zhang',
      position: '전 Tesla VP',
      company: '경영 자문'
    },
    {
      name: 'Dr. Robert Taylor',
      position: 'FDA 전 심사위원',
      company: '규제 자문'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            전문가 팀 & 자문단
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            세계 최고 수준의 전문가들이 모인 팀과 함께 혁신적인 바이오 기술을 개발하고 있습니다.
          </p>
        </div>

        {/* 핵심 팀 */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">핵심 팀</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-center">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                  />
                  <h4 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h4>
                  <div className="text-blue-600 font-medium mb-3">{member.position}</div>
                  <p className="text-gray-600 text-sm mb-4">{member.bio}</p>
                  <a 
                    href={member.linkedin}
                    className="inline-flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
                  >
                    <i className="ri-linkedin-fill mr-2"></i>
                    LinkedIn
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 자문단 */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">자문단</h3>
          <div className="grid md:grid-cols-3 gap-8">
            {advisors.map((advisor, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg text-center">
                <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-user-line text-2xl text-gray-500"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-1">{advisor.name}</h4>
                <div className="text-gray-600 mb-1">{advisor.position}</div>
                <div className="text-blue-600 text-sm font-medium">{advisor.company}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 팀 강점 */}
        <div className="mt-16 bg-blue-600 text-white rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-center mb-12">우리 팀의 강점</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-blue-100">연구 논문 발표</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">25</div>
              <div className="text-blue-100">국제 특허 보유</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">15년</div>
              <div className="text-blue-100">평균 업계 경험</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
